import { DiagnosticReportRowData } from "../tables/notes/diagnostic-reports-rows";
import { FilterOption, appendNotSpecifiedFilterOption } from "./filter-helpers";

/**
 * Create filter options for DiagnosticReport data based on actual values
 * Similar to V1's createReportsFilterToggles but for V2 structure
 */
export function createDiagnosticReportFilters(rows: DiagnosticReportRowData[]): FilterOption[] {
  const filters: FilterOption[] = [];

  if (!rows || rows.length === 0) {
    return filters;
  }

  // Extract unique categories and specialties
  const categories = new Set<string>();
  const specialties = new Set<string>();

  rows.forEach(row => {
    if (row.noteCategory && row.noteCategory !== "-") {
      categories.add(row.noteCategory);
    }
    if (row.specialty && row.specialty !== "-") {
      specialties.add(row.specialty);
    }
  });

  // Create category filters
  Array.from(categories)
    .sort()
    .forEach(category => {
      filters.push({
        label: category,
        groupLabel: "Category",
        value: `category:${category}`,
      });
    });

  // Create specialty filters
  Array.from(specialties)
    .sort()
    .forEach(specialty => {
      filters.push({
        label: specialty,
        groupLabel: "Specialty",
        value: `specialty:${specialty}`,
      });
    });

  // Automatically add "Not Specified" for each group
  return appendNotSpecifiedFilterOption(filters);
}
